<template>
  <div class="recollect-data-table">
    <data-table
      :header="header"
      @sort="handleSort"
    >
      <spinner v-if="isLoadingStatusSubmit" />
      <div v-else>
        <recollect-row :recollects="recollectsFilteredByPendingStatus" />
        <recollect-row :recollects="recollectsFilteredByResolvedStatus" />
      </div>
    </data-table>

    <infinite-loading
      :key="keyInfiniteLoading"
      slot="append"
      ref="infiniteLoading"
      :identifier="recollectForceUpdatedInfiniteLoading"
      :force-use-infinite-wrapper="true"
      @infinite="onInfinite"
    >
      <span slot="no-more" />
      <span slot="no-results" />
      <span
        slot="spinner"
        class="spinner"
        :class="{ 'spinner--small': recollectList.length > 0 }"
      >
        <spinner />
      </span>
    </infinite-loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import strings from '@/strings'
import {
  RECOLLECT_RESOLVED_STATUS,
  RECOLLECT_PENDING_STATUS,
  RECOLLECT_DISPENSED_STATUS,
  RECOLLECT_DISPENSED_NEW_OS_STATUS
} from '@/enums'

import Spinner from '../common/Spinner'
import DataTable from '../common/dataTable/DataTable'
import RecollectRow from './RecollectRow'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'RecollectDataTable',
  components: {
    DataTable,
    Spinner,
    InfiniteLoading,
    RecollectRow
  },
  data() {
    return {
      status: strings.recollectStatus,
      header: [
        {
          title: 'Data',
          subtitle: 'hora',
          value: 'createdAt',
          sort: true,
          size: 10
        },
        {
          title: 'Os Àlvaro',
          subtitle: 'Os Lis',
          value: 'orderId',
          sort: true,
          size: 10
        },
        {
          title: 'Nome',
          value: 'patientName',
          sort: true,
          size: 20
        },
        {
          title: 'Exames',
          value: 'exames',
          sort: false,
          size: 10
        },
        {
          title: 'Motivo',
          value: 'reason',
          sort: false,
          size: 15
        },
        {
          title: 'Status',
          value: 'status',
          sort: false,
          size: 10
        },
        {
          title: 'Data Ação',
          subtitle: 'hora Ação',
          value: 'dispensedAt',
          sort: false,
          size: 10
        },
        {
          title: 'Ação',
          value: 'action',
          sort: false,
          size: 15
        }
      ],
      sort: '',
      order: '',
    }
  },
  computed: {
    ...mapGetters([
      'recollectList',
      'totalRecollectsForPagination',
      'recollectParans',
      'isLoadingStatusSubmit',
      'recollectsCurrentTab',
      'recollectForceUpdatedInfiniteLoading',
      'recollectOffest'
    ]),
    recollectsFilteredByPendingStatus() {
      return this.recollectList.filter(item => item.status === RECOLLECT_PENDING_STATUS)
    },
    recollectsFilteredByResolvedStatus() {
      return this.recollectList.filter(item => {
        return (
          item.status === RECOLLECT_RESOLVED_STATUS ||
          item.status === RECOLLECT_DISPENSED_STATUS ||
          item.status === RECOLLECT_DISPENSED_NEW_OS_STATUS
        )
      })
    },
    keyInfiniteLoading() {
      return this.recollectForceUpdatedInfiniteLoading?.toString()
    }
  },
  methods: {
    ...mapActions(['selectRecollectParams', 'fetchRecollectListForTable']),

    async onInfinite($state) {

      try {
        await this.fetchRecollectListForTable();
        if (this.recollectList.length === 0 || this.recollectOffest > this.totalRecollectsForPagination) {
          $state.complete();
        } else {
          $state.loaded();
        }
      } catch (error) {
        $state.complete();
      }
    },

    handleSort(sortState) {
      this.sort = sortState.value
      this.order = sortState.order
      this.selectRecollectParams({
        ...this.recollectParans,
        orderByProperty: sortState.value,
        orderByDirection: sortState.order,
        offset: undefined
      })
      this.getRecollectList()
    }
  }
}
</script>

<style lang="scss">
.recollect-data-table {
  hr {
    margin-bottom: 1em;
  }

  .text-color-tundora {
    color: #363636;
  }

  .data-table__body__row {
    &__cell {
      font-family: Roboto, sans-serif;
      font-style: normal;

      h3 {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
      }

      p {
        color: #363636;
        font-family: 'Exo 2';
        font-style: normal;
        font-weight: 600;
        line-height: 14px !important;
      }
    }
  }

  p.sub {
    color: rgba(22, 22, 22, 0.24);
  }

  span {
    font-weight: normal;
  }

  span.reason {
    font-weight: bold;
  }

  .overflow-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .status {
    font-weight: bold;
    font-family: Roboto, sans-serif;
    font-style: normal;
    text-transform: uppercase;
    font-size: 12px;
    padding-left: 16px;
    line-height: 1.3em;
    position: relative;
    display: flex;
    align-items: center;

    &::before {
      content: '';
      position: absolute;
      height: 7px;
      width: 7px;
      border-radius: 50%;
      border: 4px solid;
      left: 0;
      top: 3px;
    }

    &-orange {
      color: #f5a623 !important;
    }

    &-green {
      color: #55cd9e !important;
    }

    &-gray {
      color: #919191 !important;
    }
  }

  .empty-search {
    width: 25%;
    position: relative;
    margin: 6% auto auto;

    .md-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 1em;
      margin-left: 40%;
    }

    p {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #7a7a7a;
    }
  }

  .spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;

    &--small {
      min-height: 100px;
      margin-bottom: 25px;

      .loader {
        width: 60px;
        height: 60px;
        border-top: 0.6em solid rgba(127, 26, 84, 0.2);
        border-right: 0.6em solid rgba(127, 26, 84, 0.2);
        border-bottom: 0.6em solid rgba(127, 26, 84, 0.2);
        border-left: 0.6em solid #7f1a54;
      }
    }
  }
}
</style>
